import React, { useState } from 'react';
import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import { ContentCopy as CopyIcon, Check as CheckIcon } from '@mui/icons-material';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { oneDark } from 'react-syntax-highlighter/dist/esm/styles/prism';

/**
 * Code block with syntax highlighting and copy button.
 * Always uses dark theme regardless of app theme.
 */
const CodeBlock = ({ language, value }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  return (
    <Box sx={{ position: 'relative', my: 1.5, borderRadius: 1, overflow: 'hidden' }}>
      {/* Language label + copy button header */}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          px: 2,
          py: 0.5,
          backgroundColor: '#1e1e1e',
          borderBottom: '1px solid #333',
        }}
      >
        <Typography variant="caption" sx={{ color: '#999', fontFamily: 'monospace' }}>
          {language || 'text'}
        </Typography>
        <Tooltip title={copied ? 'Copied!' : 'Copy code'} placement="top">
          <IconButton
            size="small"
            onClick={handleCopy}
            sx={{ color: copied ? '#4caf50' : '#999', '&:hover': { color: '#fff' } }}
          >
            {copied ? <CheckIcon fontSize="small" /> : <CopyIcon fontSize="small" />}
          </IconButton>
        </Tooltip>
      </Box>

      <SyntaxHighlighter
        language={language || 'text'}
        style={oneDark}
        customStyle={{
          margin: 0,
          borderRadius: 0,
          fontSize: '0.85rem',
          lineHeight: 1.5,
        }}
        showLineNumbers={value && value.split('\n').length > 5}
      >
        {value || ''}
      </SyntaxHighlighter>
    </Box>
  );
};

export default CodeBlock;
